import i18n from "@/i18n/i18n"

export const UserStatusOptions = [
  {
    label: i18n.t('正常'),
    value: '0'
  },
  {
    label: i18n.t('禁用'),
    value: '1'
  },
]